import get_spell_name from './get_spell_name.js';

const buildSpellbook = async (chardata, globalState, setSpellbook) => {

  let spellbookData = [];

  // if All Spells in not yet defined, return nothing
  if (globalState[7][0] === undefined) {
    return spellbookData;
  }

  const charClass = chardata?.myClass;

  // Determine spell class list
  const spellClassList = [];
  if (charClass.match(/Mage|MU|Magic-User/i)) spellClassList.push('Mage');
  if (charClass.match(/Cleric|Cl|CL|cl/i)) spellClassList.push('Cleric');
  if (charClass.match(/Druid|Dr|DR|dr/i)) spellClassList.push('Druid');
  if (charClass.match(/Illusionist|Ill|ILL|ill/i)) spellClassList.push('Illusion');

  // Iterate through all chardata object
  for (const [key, spellName] of Object.entries(chardata)) {
    
    // exit quickly if no data
    if (!spellName) continue;

    // only interested in data fields starting with 'mySp'
    if (key.startsWith('mySp') && !key.startsWith('mySpk')) {

      if (spellName === '') continue; // Skip empty spells

      // attempt to look up the spell in the All Spells array (globalState[7][0])
      if (globalState[7][0].length !== 0) {
        try {
          const spell_to_search = await get_spell_name(spellName, globalState);

          const thisSpell = globalState[7][0].find(
            spell => spell && spell.Name === spell_to_search && spellClassList.includes(spell.Class)
          );
          
          if (thisSpell) {
            spellbookData.push(thisSpell);
          }
        } catch (error) {
          console.error(`Error fetching spell ${spellName}:`, error);
          console.log(`globalState[7][0]:`, globalState[7][0]);
        }
      }
    }
  }

  // Remove any spells with undefined Class or Lvl before sorting
  spellbookData = spellbookData.filter(spell => spell.Class !== undefined && spell.Lvl !== undefined);

  // Remove duplicates based on Name and Class
  const uniqueSpells = new Map();
  spellbookData.forEach(spell => {
    const key = `${spell.Name}-${spell.Class}`;
    if (!uniqueSpells.has(key)) {
      uniqueSpells.set(key, spell);
    }
  });
  spellbookData = Array.from(uniqueSpells.values());

  // Sort spells by Class, then Level, then Name
  spellbookData.sort((a, b) => {
    const aClass = a.Class || '';
    const bClass = b.Class || '';
    const cmpClass = aClass.localeCompare(bClass);
    if (cmpClass !== 0) return cmpClass;

    const aLvl = (a.Lvl !== undefined && a.Lvl !== null) ? a.Lvl : 0;
    const bLvl = (b.Lvl !== undefined && b.Lvl !== null) ? b.Lvl : 0;
    if (aLvl !== bLvl) return aLvl - bLvl;

    const aName = a.Name || '';
    const bName = b.Name || '';
    return aName.localeCompare(bName);
  });

  console.log('spellbook data', spellbookData)
  setSpellbook(spellbookData);
  
  return spellbookData;

};

export default buildSpellbook;